const { mainConfigService } = require('./services/config');
const { LANGUAGES } = require('./constants');

const langs = {
  ar: {
    'Payment Details': 'تفاصيل الدفع',
    'Total Bill': 'إجمالي المبلغ',
    'Debit / Credit Card': 'بطاقة الصراف الآلي / بطاقة ائتمان',
    'Name On Card': 'الاسم على البطاقة',
    'Card Number': 'رقم البطاقة',
    'Click To Save Your Card': 'احفظ البطاقة',
    'You have incorrectly entered your expiration date': 'لقد أدخلت تاريخ انتهاء الصلاحية بشكل غير صحيح',
    'Saved Cards': 'البطاقات المحفوظة',
    'List of all cards saved': 'قائمة البطاقات المحفوظة',
    'Expires on': 'تنتهي في',
    'Expired on': 'انتهت في',
    'Expired': 'انتهت',
    'Click Confirm if you don\'t want this payment method to be displayed in your payment options': 'إذا كنت لا تريد عرض طريقة الدفع هذه في خيارات الدفع',
    'Delete': 'حذف',
    'Cancel': 'الغاء',
    'Payment Failed': 'فشل عملية الدفع',
    'Alert': 'تنبيه',
    'OK': 'موافق',
    'Remove': 'حذف',
    'Expiry': 'تاريخ انتهاء الصلاحية',
    'CCV': 'رمز التحقق من البطاقة',
    'MM/YY': 'شهر/سنة',
    'Pay Now': 'ادفع الآن',
    'This field is required': 'حقل مطلوب',
    'Invalid Card Number': 'رقم البطاقة غير صحيح',
    'Payment Method': 'وسيلة دفع',
    'List of all gateways we support': 'قائمة بجميع بوابات الدفع التي ندعمها',
    'Fees': 'رسوم',
    'Total': 'الاجمالي',
    'Sub-Total': 'المجموع',
    'Apple Pay is unavailable. Please update your device, set up Wallet, add an active card, ensure the domain is verified by Apple, and refresh the page.':'الدفع عن طريق Apple Pay غير متاح. من فضلك  قم بتحديث جهازك. ومن ثم انشئ المحفظة واضف كارت  بنكي. وتأكد ان النطاق معتمد عبر ابل. واعد تحديث الصفحة',
    'Payment Methods': 'وسائل الدفع', 
    'Confirm Phone Number': 'رقم الهاتف المحمول',
    'Send OTP': 'إرسال الرمز',
    'Sending...': 'جارٍ الإرسال...',
    'Enter OTP': ' الرجاء إدخال كلمة مرور لمرة واحدة ',
    'Pay': 'إدفع',
    'Please Enter a valid Phone Number': ' الرجاء إدخال رقم صحيح للهاتف المحمول ',
    'Something Went Wrong': 'حدث خطأ',
    'Mobile Number': 'رقم الهاتف المحمول',
    'OTP':'كلمة مرور لمرة واحدة ',
    'Resend OTP':' اعادة ارسال كلمة مرور لمرة واحدة ',
    'Sec': '  ثانية ',
    'Save STC Account':'حفظ البطاقة',
    'Please enter a valid mobile number':'الرجاء ادخال رقم هاتف صحيح',
    'Please enter OTP': 'من فضلك ادخل كلمة مرور لمرة واحدة ',
    'Please Enter OTP': 'من فضلك ادخل كلمة مرور لمرة واحدة ',
    'Enter Mobile Number': 'من فضلك ادخل رقم الهاتف المحمول',
    'Or Pay With': 'او ادفع بواسطة',
    'Pay With': 'ادفع بواسطة',
    'Amount': 'المبلغ' ,
    'Save your card for faster future payments': 'لدفع سريع وآمن , احفظ بطاقة الدفع',
    'Installments Payment option is Not available for you': 'خيار الدفع بالتقسيط غير متاح لك',
    'Sorry, Tabby is unable to approve this purchase':'نأسف، تابي غير قادرة على الموافقة على هذه العملية',
    'Sorry, Taly is unable to approve this purchase':'نأسف، تالي غير قادرة على الموافقة على هذه العملية',
    'Tamara': 'تمارا',
    'Pay in 4 interest-free payments': 'قسّمها على 4 دفعات بدون فوائد',
    'Split your payment with Taly': 'قسّم دفعتك مع تالي',
    'Reject': 'الغاء',
    'Are you sure you want to cancel the transaction?': 'هل انت متأكد من انك تريد الغاء العملية؟',
    'Yes': 'نعم',
    'No': 'لا',
    'Error': 'خطأ',
    'Try Again': 'حاول مرة اخرى',
    'Ask a friend to pay to complete payment': 'اطلب من صديق الدفع لإتمام العملية.',
    'Order total:': 'إجمالي الطلب',
    'Please complete payment within': 'يرجى إتمام الدفع خلال',
    'Send to friend': 'إرسال إلى صديق',
    'Change payment method': 'تغيير طريقة الدفع',
    'Already paid?': 'هل تم الدفع؟', 
    'Update': 'تحديث',
    'We\'ll email you a confirmation once payment is complete.': 'سنرسل لك رسالة تأكيد عبر البريد الإلكتروني بمجرد إتمام الدفع.',
    'Payment completed': 'تم الدفع بنجاح',
    'Your friend has paid for your order. Thank you!': 'لقد دفع صديقك مقابل طلبك. شكراً لك!',
    'Payment pending': 'الدفع قيد الانتظار',
    'Your friend has not paid yet': 'لم يدفع صديقك الى الان',
    'Unable to check payment status': 'تعذر التحقق من حالة الدفع',
    'Please try again later or contact support': 'يرجى المحاولة مرة أخرى لاحقاً أو الاتصال بالدعم',
    'Ask a friend to pay for you!': 'اطلب من صديق الدفع عنك!',
    'Total to be paid:': 'المبلغ المطلوب دفعه:',
    'Leave a message encouraging your friend to help you out.': 'اترك رسالة لتشجيع صديقك على مساعدتك.',
    'Change message!': 'غيّر الرسالة!',
    'Share Via:': 'المشاركة عبر:',
    'Sharing lets your friend see the order details and complete the payment for you.': 'تتيح المشاركة لصديقك عرض تفاصيل الطلب وإتمام الدفع بدلًا منك.',
    'We\'ll create a link so someone else can pay for your order.': 'سننشئ رابطًا ليتمكّن شخص آخر من دفع قيمة طلبك.',
    'day': 'يوم',
    'days': 'يوم',
    'days_two': 'يومان',
    'hour': 'ساعة',
    'hours': 'ساعة',
    'hours_two': 'ساعتان',
    'Payment Link Expired': 'انتهت صلاحية الرابط',
    'The payment link has expired and your friend can no longer complete the payment.': 'لقد انتهت صلاحية الرابط ولن يتمكن صديقك من اكمال الدفع',
    'Your order is created but not paid yet. Share the link with a friend so they can pay for you.': 'تم إنشاء طلبك لكنه غير مدفوع بعد. شارك الرابط مع صديق ليتمكن من الدفع بدلًا منك.',
    'Would you mind helping me out with this payment? Thanks!': 'هل تمانع في مساعدتي بدفع هذا الطلب؟ شكرًا لك!',
    'Agree to': 'أوافق على',
    'Terms & Conditions': 'الشروط والأحكام',
    'Accept Terms and Conditions to continue the payment': 'يرجى الموافقة على الشروط والأحكام لمتابعة الدفع',
    'By clicking pay button you are accepting our': 'بالنقر على زر الدفع فإنك توافق على',
    'Our checkout is safe and secure. Your payment information is encrypted and protected by industry-standard security protocols.': 'عملية الدفع آمنة ومحمية. معلومات الدفع الخاصة بك مشفرة ومحمية بموجب بروتوكولات الأمان المعتمدة.',
    'Show more': 'عرض المزيد',
    'Show less': 'عرض أقل',
    'Wallet Error': 'خطأ في المحفظة',
    'Pay faster using funds already in your wallet. If your balance doesn\'t cover the full amount, you can pay the rest with another method.': 'ادفع بشكل أسرع باستخدام الرصيد الموجود في محفظتك. إذا لم يغطِ رصيدك المبلغ الكامل، يمكنك دفع الباقي بطريقة أخرى.',
    'Loyalty Points': 'نقاط الولاء',
    'How much would you like to redeem?': 'كم تريد استخدام من نقاطك؟',
    'Custom': 'مخصص',
    'Custom amount': 'مبلغ مخصص',
    'Please enter...': 'أدخل...',
    'Apply': 'تطبيق',
    'Verify your transaction to use your loyalty points. Tap to request an OTP sent to your number ending in {phone} and redeem your points.': 'تحقق من معاملتك لاستخدام نقاط ولائك. اضغط لطلب رمز يُرسل إلى رقمك المنتهي بـ {phone} واسترد نقاطك.',
    'Invalid OTP': 'رمز التحقق غير صحيح',
    'Unable to Send Verification Code': 'تعذر إرسال رمز التحقق',
    'Loyalty Redemption Failed': 'فشل استرداد نقاط الولاء',
    'Enter the 4-digit code': 'أدخل الرمز المكون من 4 أرقام',
    'Sent to': 'أُرسل إلى',
    'Change': 'تغيير',
    'Didn\'t get it?': 'لم تستلمه؟',
    'Resend in': 'إعادة الإرسال خلال',
    'Resend code': 'إعادة إرسال الرمز', 
    'Skip loyalty for this payment': 'تخطي نقاط الولاء لهذه الدفعة',
    'Verifying OTP...': 'جارٍ التحقق من الرمز...',
    'Available balance:': 'الرصيد المتاح:',
    'Points': 'نقطة',
    'Max': 'الحد الأقصى',
    'You\'ll save {amount} with loyalty points': 'ستوفر {amount} باستخدام نقاط الولاء',
    'Balance:': 'الرصيد:',
    'Choose another payment method to complete the remaining amount': 'اختر وسيلة دفع أخرى لإتمام المبلغ المتبقي',
    'Points & card are charged together. If card fails, your points are not deducted.': 'يتم خصم النقاط والبطاقة معًا. إذا فشلت البطاقة، لن تُخصم نقاطك.',
    'The transaction has failed.': 'فشلت العملية.',
    'Kindly review your payment information or contact support for assistance': 'يرجى مراجعة بيانات الدفع أو التواصل مع الدعم للمساعدة',
    'Loyalty Applied:': 'نقاط الولاء المستخدمة:',
    'Remaining:': 'المتبقي:',
    'Full payment covered by loyalty points': 'تم تغطية المبلغ بالكامل بنقاط الولاء',
    'Fully covered by Loyalty Points': 'مغطى بالكامل بنقاط الولاء',
    'Select a payment method below to complete your payment': 'اختر وسيلة دفع أدناه لإتمام عملية الدفع',
    'Select another payment method to complete your payment': 'اختر وسيلة دفع أخرى لإتمام عملية الدفع',
    'Summary': 'الملخص',
    'Subtotal': 'المجموع الفرعي',
    'Payment Fees': 'رسوم الدفع',
    'Please enter a whole number': 'يرجى إدخال رقم صحيح',
    'Maximum amount:': 'الحد الأقصى للمبلغ:',
    'Something went wrong.': 'حدث خطأ.',
    'Please try again or select another payment method.': 'يرجى المحاولة مرة أخرى أو اختيار وسيلة دفع أخرى.',
  }
};

const $t = (text) => {
  if (!text) return '';
  text = String(text);
  const currentLang = mainConfigService.get('lang');
  if (langs[currentLang] && langs[currentLang][text]) {
    return langs[currentLang][text];
  } else {
    return text;
  }
};

const $payButtonText = () => {

  const fallbackTranslations = {
    'en': 'Pay',
    'ar': 'إدفع'
  };

  const currentLang = mainConfigService.get('lang');
  const payButtonText = mainConfigService.get('payButtonText');

  if (payButtonText) { 
    const lang = currentLang || LANGUAGES.EN;
    return payButtonText[lang] || fallbackTranslations[lang];
  }
  
  return fallbackTranslations[currentLang || LANGUAGES.EN];
};

const $rejectButtonText = () => {
  const fallbackTranslations = {
    'en': 'Reject',
    'ar': 'الغاء'
  };
  const currentLang = mainConfigService.get('lang');
  const lang = currentLang || LANGUAGES.EN;
  const rejectButtonConfig = mainConfigService.get('rejectButtonConfig');
  if (rejectButtonConfig && rejectButtonConfig.text) {
    return rejectButtonConfig.text[lang] || fallbackTranslations[lang];
  }
  return fallbackTranslations[lang];
};

exports.$t = $t;
exports.$payButtonText = $payButtonText;
exports.$rejectButtonText = $rejectButtonText;